import apiPath from '@store/apiPath'

export default {
  /**
   * 챗봇 시작
   * @method POST
   */
  FETCH_CHATBOT_OPENING: `${apiPath.CHATBOT}/new`,
  /**
   * 챗봇 채팅
   * @method POST
   */
  CREATE_CHAT_BOT_CHATTING_POST: `${apiPath.CHATBOT}/msg-send`,
  /**
   * 챗봇 종료
   * @method PUT
   */
  EDIT_CHAT_BOT_CHATTING_CLOSE: `${apiPath.CHATBOT}/end`,
}
